import BaseContainer from "@/components/baseContainer";
import EmailChangeForm from "@/components/form/emailChangeForm";
import { WP_URL } from "@/config";
import { linkToIframe } from "@/utiils";

const MailChangePage = () => {
  const onLoginComplete = () => {
    linkToIframe('/user', {isIframeUrl: WP_URL + '/mypage'});
  };

  const onRegister = () => {
    linkToIframe('/user/register', {isIframeUrl: WP_URL + '/register'});
  };

  return (
    <div className="my-16">
      <BaseContainer>
        <EmailChangeForm onComplete={onLoginComplete} />
      </BaseContainer>
    </div>
  );
};

export default MailChangePage;